export const reducerTypes = {
  TOGGLE_ADMIN: "reducer/TOGGLE_ADMIN",
};
